import { MACRO_KEY } from "../optics/defaults";
import { useAdvancedTabsGroupStore } from "./use-advanced-tabs-group-store";
import { useAdvancedTabsSingleStore } from "./use-advanced-tabs-single-store";
import { useAnnouncementsStore } from "./use-announcements-store";
import { useButtonInlineStore } from "./use-button-inline-store";
import { useButtonStore } from "./use-button-store";
import { useCardsStore } from "./use-cards-store";
import { useCountdownStore } from "./use-countdown-store";
import { useEasyHtmlStore } from "./use-easyhtml-store";
import { useFootnoteDisplayStore } from "./use-footnotedisplay-store";
import { useImageSliderStore } from "./use-image-slider-store";
import { useNewStartersStore } from "./use-new-starters-store";
import { useNewsStore } from "./use-news-store";
import { useEmptyStore } from "./use-optics-store";
import { useOrgChartStore } from "./use-org-chart-store";
import { usePagesStore } from "./use-page-store";
import { usePanelAdvancedStore } from "./use-panel-advanced-store";
import { usePanelSimpleStore } from "./use-panel-simple-store";
import { usePeopleStore } from "./use-people-store";
import { useRecentlyActiveStore } from "./use-recently-active-store";
import { useSpacesStore } from "./use-space-store";
import { useSpacerAndDividerStore } from "./use-spacer-and-divider-store";
import { useTitleTextStore } from "./use-titletext-store";
import { useTooltipFootnoteStore } from "./use-tooltip-footnote-store";
import { useUpcomingBirthdayStore } from "./use-upcoming-birthdays-store";
import { useWorkAnniversaryStore } from "./use-work-anniversary-store";

export const macroStores = {
  [MACRO_KEY.BUTTON]: useButtonStore,
  [MACRO_KEY.PANEL_SIMPLE]: usePanelSimpleStore,
  [MACRO_KEY.CARDS]: useCardsStore,
  [MACRO_KEY.COUNTDOWN]: useCountdownStore,
  [MACRO_KEY.ANNOUNCEMENTS]: useAnnouncementsStore,
  [MACRO_KEY.TABS]: useEmptyStore,
  [MACRO_KEY.HTML]: useEmptyStore,
  [MACRO_KEY.IMAGE_SLIDER]: useEmptyStore,
  [MACRO_KEY.SPACER_AND_DIVIDER]: useSpacerAndDividerStore,
  [MACRO_KEY.TEXT_AND_TITLE]: useTitleTextStore,
  [MACRO_KEY.IMAGE_SLIDER]: useImageSliderStore,
  [MACRO_KEY.FOOTNOTE_DISPLAY]: useFootnoteDisplayStore,
  [MACRO_KEY.TOOLTIPS_AND_FOOTNOTES]: useTooltipFootnoteStore,
  [MACRO_KEY.ADVANCED_TABS_GROUP]: useAdvancedTabsGroupStore,
  [MACRO_KEY.ADVANCED_TABS_SINGLE]: useAdvancedTabsSingleStore,
  [MACRO_KEY.PANEL_ADVANCED]: usePanelAdvancedStore,
  [MACRO_KEY.BUTTON_INLINE]: useButtonInlineStore,
  [MACRO_KEY.HTML]: useEasyHtmlStore,
  [MACRO_KEY.PEOPLE]: usePeopleStore,
  [MACRO_KEY.NEWS]: useNewsStore,
  [MACRO_KEY.PAGES]: usePagesStore,
  [MACRO_KEY.SPACES]: useSpacesStore,
  [MACRO_KEY.RECENTLY_ACTIVE]: useRecentlyActiveStore,
  [MACRO_KEY.UPCOMING_BIRTHDAYS]: useUpcomingBirthdayStore,
  [MACRO_KEY.NEW_STARTERS]: useNewStartersStore,
  [MACRO_KEY.WORK_ANNIVERSARY]: useWorkAnniversaryStore,
  [MACRO_KEY.ORG_CHART]: useOrgChartStore,

  [MACRO_KEY.OTHER_MODULES_KEY]: useEmptyStore,
  [MACRO_KEY.OVERVIEW_KEY]: useEmptyStore,
  [undefined]: useEmptyStore,
};

export const buttonStores = {
  [MACRO_KEY.BUTTON]: useButtonStore,
  [MACRO_KEY.BUTTON_INLINE]: useButtonInlineStore,
};
